export const setDoaTrialSearchParams = (searchParams, { trialId, siteId, siteTrialId }) => {
  const next = new URLSearchParams(searchParams);
  if (trialId != null) next.set('trialId', String(trialId));
  if (siteId != null) next.set('siteId', String(siteId));
  if (siteTrialId != null) next.set('siteTrialId', String(siteTrialId));
  return next;
};

export const buildDoaNavigateTarget = (pathname, searchParams) => {
  const query = searchParams?.toString();
  return query ? { pathname, search: `?${query}` } : { pathname };
};

export const findDoaTrialMatch = (trials, trialId, siteId) =>
  trials.find(
    (entry) =>
      String(entry.trial?.id) === String(trialId) && String(entry.site?.id) === String(siteId)
  );
